export const checkForDefaultError = (e) => {
  return e.response && e.response.data.errors && e.response.data.errors.default && e.response.data.errors.default.msg
}
